import { IShapeDrawableObject, instanceOfIShapeDrawableObject } from "./IShapeDrawableObject";

export interface ICrossObject extends IShapeDrawableObject {}

export function instanceOfICrossObject(instance: any): instance is ICrossObject {
  return instanceOfIShapeDrawableObject<ICrossObject>(instance, "cross");
}
